import React from "react";

function NotFound() {
  return <div>요청 페이지를 찾을 수 없습니다</div>;
}

export default NotFound;
